// components
import { Title } from '../Title/Title';
import { Points } from './points';
import { DescriptionDesktop } from './description-desktop/description-desktop';

// utils
import { TitleFormats } from '../Title/title.types';

interface InteractiveDescriptionProps {
  border: string;
  title: string;
  subtitle: string;
  isChild: boolean;
  sectionId?: string;
}

export function InteractiveDescriptionDesktop({
  border,
  title,
  subtitle,
  isChild,
  sectionId,
}: Readonly<InteractiveDescriptionProps>) {
  const borderStyle = border === 'disable-border' ? `interactive-description--${border}` : '';

  return (
    <div className="grid-container">
      <div className={`interactive-description ${borderStyle}`} id={sectionId}>
        <Title
          title={title}
          subtitle={subtitle}
          Format={isChild ? TitleFormats.h4 : TitleFormats.h2}
          formatClassName="h3"
        />
        <div className="interactive-description__wrapper grid-x">
          <div className="interactive-description__stage small-12 large-6">
            <Points />
          </div>
          {<DescriptionDesktop />}
        </div>
      </div>
    </div>
  );
}
